import '../typedefs'
import http from '@/http'

export default {
    /**
     * @param {ProductsQuery} query
     * @returns {Promise<void>}
     */
    async searchProducts (query = {}) {
        try {
            const response = await http.get('/products/inventory', {
                params: query
            })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ProductQuery} data
     * @returns {Promise<void>}
     */
    async showProduct (data) {
        try {
            const response = await http.get(`/products/inventory/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ProductInventoryItem} data
     * @returns {Promise<void>}
     */
    async createProduct (data) {
        try {
            const response = await http.post('/products/inventory', data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ProductInventoryItem} data
     * @returns {Promise<void>}
     */
    async updateProduct (data) {
        try {
            const response = await http.put(`/products/inventory/${data.id}`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ProductInventoryItem} data
     * @returns {Promise<void>}
     */
    async removeProduct (data) {
        try {
            const response = await http.delete(`/products/inventory/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
